/** Valid tarp selections per day: 0, 1/2, 1, 1 1/2, or 2. Empty ("-") is allowed / optional. */
export const TARP_VALUES = ['0', '1/2', '1', '1 1/2', '2'];

const TARP_NUMERIC = {
    '0': 0,
    '1/2': 0.5,
    '1': 1,
    '1 1/2': 1.5,
    '2': 2,
};

export function normalizeTarpValue(v) {
    if (v === 'yes') return '1';
    if (v === 'no') return '0';
    if (TARP_VALUES.includes(v)) return v;
    return '';
}

export function isValidTarpSelection(v) {
    return TARP_VALUES.includes(normalizeTarpValue(v));
}

export function formatTarpCell(v) {
    const n = normalizeTarpValue(v);
    return n || '-';
}

export function sumTarps(values) {
    return (values || []).reduce((total, raw) => {
        const v = normalizeTarpValue(raw);
        if (v in TARP_NUMERIC) return total + TARP_NUMERIC[v];
        return total;
    }, 0);
}

export function formatTarpTotal(sum) {
    if (!Number.isFinite(sum)) return '0';
    return Number.isInteger(sum) ? String(sum) : sum.toFixed(1);
}
